import Vue from 'vue'
import "vue-easytable/libs/theme-default/index.css"; // import style


Vue.mixin({
    methods:{
        topFlopDataToTable:(data)=>{


            var listStore=[]
            var listStoreName=[]
            var listTimeWeek=[]
            // var posisiTimeWeek
            var valueTimeWeek=[]
            var key
            data.map(e=>{
                key=e.Tahun+""+e.WeekNo
                Object.assign(e,{timeWeek:key})                
                if(listStore.indexOf(e.BranchID)===-1) {
                    listStore.push(e.BranchID)
                }
                if(listStoreName.indexOf(e.BranchName)===-1) {
                    listStoreName.push(e.BranchName)
                }
                if(listTimeWeek.indexOf(key)===-1) {
                    listTimeWeek.push(key)
                } 
            })

           data.map(e=>{
            // if(listStore.indexOf(e.BranchID)===-1) listStore.push(e.BranchID)
            // if(listTimeWeek.indexOf(e.timeWeek)===-1) listTimeWeek.push(e.timeWeek)
            // var posisiTimeWeek=listTimeWeek.indexOf(e.timeWeek)


//            var isiData={id:e.BranchID,ranking:e.Rank,sales:e.SalesExTax,timeWeek:e.timeWeek,posisiTimeWeek:posisiTimeWeek}
            if(Array.isArray(valueTimeWeek[listTimeWeek.indexOf(e.timeWeek)])===false)
            valueTimeWeek[listTimeWeek.indexOf(e.timeWeek)]=[]
//            valueTimeWeek[listTimeWeek.indexOf(e.timeWeek)].push(isiData)
            

       })



           var newData={}
           newData["listStore"]=listStore
           newData["listStoreName"]=listStoreName
           newData["listTimeWeek"]=listTimeWeek
//           newData["valueTimeWeek"]=valueTimeWeek


           /*
           var column={}
           column['field']="storeid"
           column['key']="a"
           column['title']="storeid"
           newData["columns"][0]=column
           var column2={}
           column2['field']="name"
           column2['key']="a"
           column2['title']="name"
           newData["columns"][1]=column2
           */

           /*

            konversi datake table ve-table
            1. buat field header & sub header
            2. buat table data

           */
            newData["columns"]=[]
            var arrayData={}
           var i=0;
           arrayData['title']="Store"
           arrayData['children']=[]
           arrayData['children'][0]={}
           arrayData['children'][0]['title']='ID'
           arrayData['children'][0]['field']='storeId'
           arrayData['children'][0]['key']='storeId'
           arrayData['children'][0]['align']='left'
           arrayData['children'][0]['sortBy']='asc'
           arrayData['children'][1]={}
           arrayData['children'][1]['title']='Name'
           arrayData['children'][1]['field']='storeName'
           arrayData['children'][1]['key']='storeName'
           arrayData['children'][1]['align']='left'
           arrayData['children'][1]['sortBy']=''
           newData["columns"].push(arrayData)


           for( i=0; i<listTimeWeek.length; i++){
                
                arrayData={}
                arrayData['title']=listTimeWeek[i].slice(4,6)
                arrayData['children']=[]
                arrayData['children'][0]={}
                arrayData['children'][0]['title']='Sales'
                arrayData['children'][0]['field']=listTimeWeek[i]+'sales'
                arrayData['children'][0]['key']=listTimeWeek[i]+'sales'
                arrayData['children'][0]['align']='center'
                arrayData['children'][0]['sortBy']='asc'
                arrayData['children'][1]={}
                arrayData['children'][1]['title']='Ranking'
                arrayData['children'][1]['field']=listTimeWeek[i]+'ranking'
                arrayData['children'][1]['key']=listTimeWeek[i]+'ranking'
                arrayData['children'][1]['align']='center'
                arrayData['children'][1]['sortBy']='asc'

                newData["columns"].push(arrayData) 

           }      

           /*

           Proses table data

           */
           newData["tableData"]=[]

           var listStoreRanking=[]
           var listStoreSales=[]

           for( i=0; i<listStore.length; i++){

            
            listStoreRanking[i]=[]
            listStoreSales[i]=[]
            for( var z=0; z<listTimeWeek.length; z++){
                    // var isidata={}
                    var nilaiRanking=0
                    var nilaiSales=0

                    var isidata=data.filter(e=>
                         {
                             return e.BranchID===listStore[i] && e.timeWeek===listTimeWeek[z]
                        }
                         )
                         if(typeof isidata!=='object' || isidata=="" || isidata==[]) isidata=null
                         else {
                            nilaiRanking=isidata[0].Rank
                            nilaiSales=(isidata[0].SalesExTax/1000000).toFixed(2)
                        }
                         listStoreRanking[i][z]=nilaiRanking
                         listStoreSales[i][z]=nilaiSales
                        }
            

                arrayData={}

            //newData["columns"].push(arrayData) 

            }      
            newData["tableData"]=[]

            for(i=0; i<listStore.length; i++){
                isidata={}
                isidata["rowkey"]=i
                isidata["storeId"]=listStore[i]
                isidata["storeName"]=listStoreName[i]
                for(z=0; z<listTimeWeek.length; z++){
                    var keyNameRanking=(listTimeWeek[z]+"ranking").toString()
                    var keyNameSales=(listTimeWeek[z]+"sales").toString()
                    isidata[keyNameSales]=listStoreSales[i][z]
                    isidata[keyNameRanking]=listStoreRanking[i][z]
                }
                //console.log("isidata",isidata)
                newData["tableData"].push(isidata)
            }

            newData["listStoreRanking"]=listStoreRanking
            newData["listStoreSales"]=listStoreSales

            newData["sortOption"]={}
            newData["sortOption"]["sortAlways"]=true
            newData["sortOption"]["multipleSort"]=true
            newData["sortOption"]["sortChange"]=(params) => {
                console.log("sortChange::", JSON.stringify(params))
                this.sortChange(params)
            }
           
            return newData

        },
        sortChange(){
            alert()
        },




    }
})